// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"side-menu-1mrjh","side-menu-hide-scroll":"side-menu-hide-scroll-2D8NF","menu-text":"menu-text-2ZrRt"};